// extracted by mini-css-extract-plugin
export var externalLink = "_av-0";
export var internalLinkLabel = "_av-1";